import {
  GOOGLE_CALENDAR_CLIENT_ID,
  MICROSOFT_CALENDAR_CLIENT_ID,
} from '~/constant';

const GOOGLE_SCOPE =
  'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.calendarlist.readonly';
const MICROSOFT_SCOPE = ['Calendars.ReadWrite'];
const scriptsCarregando = {};

const montarErroGoogleCalendar = erro => {
  if (erro && erro.message) {
    return erro;
  }

  const tipoErro = erro && (erro.type || erro.error);
  const descricaoErro =
    erro && erro.error_description ? erro.error_description : '';

  switch (tipoErro) {
    case 'popup_failed_to_open':
      return new Error('Popup do Google bloqueado pelo navegador.');
    case 'popup_closed':
      return new Error('Popup do Google fechado antes da autenticação.');
    default:
      return new Error(
        descricaoErro || 'Falha ao autenticar no Google Calendar.'
      );
  }
};

const carregarScript = src => {
  if (scriptsCarregando[src]) {
    return scriptsCarregando[src];
  }

  const scriptExistente = document.querySelector(`script[src="${src}"]`);
  if (
    scriptExistente &&
    scriptExistente.getAttribute('data-carregado') === 'true'
  ) {
    return Promise.resolve();
  }

  scriptsCarregando[src] = new Promise((resolve, reject) => {
    const script = scriptExistente || document.createElement('script');

    script.onload = () => {
      script.setAttribute('data-carregado', 'true');
      resolve();
    };
    script.onerror = error => {
      delete scriptsCarregando[src];
      reject(error);
    };

    if (!scriptExistente) {
      script.src = src;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  });

  return scriptsCarregando[src];
};

export const prepararGoogleCalendar = () =>
  window.google && window.google.accounts
    ? Promise.resolve()
    : carregarScript('https://accounts.google.com/gsi/client');

export const prepararOutlookCalendar = () =>
  window.msal
    ? Promise.resolve()
    : carregarScript(
        'https://alcdn.msauth.net/browser/2.38.3/js/msal-browser.min.js'
      );

export const solicitarTokenGoogleCalendar = () =>
  new Promise((resolve, reject) => {
    if (!GOOGLE_CALENDAR_CLIENT_ID) {
      reject(new Error('Client ID do Google Calendar não configurado.'));
      return;
    }

    const solicitarToken = () => {
      if (!window.google || !window.google.accounts) {
        reject(new Error('Google Identity Services não foi carregado.'));
        return;
      }

      const tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: GOOGLE_CALENDAR_CLIENT_ID,
        scope: GOOGLE_SCOPE,
        callback: response => {
          if (response && response.error) {
            reject(montarErroGoogleCalendar(response));
            return;
          }

          if (!response || !response.access_token) {
            reject(new Error('Token do Google Calendar não retornado.'));
            return;
          }

          resolve({
            access_token: response.access_token,
            calendar_id: 'primary',
          });
        },
        error_callback: error => reject(montarErroGoogleCalendar(error)),
      });

      tokenClient.requestAccessToken({ prompt: 'consent' });
    };

    if (window.google && window.google.accounts) {
      solicitarToken();
      return;
    }

    prepararGoogleCalendar()
      .then(solicitarToken)
      .catch(error => reject(error));
  });

export const solicitarTokenOutlookCalendar = async () => {
  if (!MICROSOFT_CALENDAR_CLIENT_ID) {
    throw new Error('Client ID do Outlook Calendar não configurado.');
  }

  await prepararOutlookCalendar();

  if (!window.msal) {
    throw new Error('Microsoft Authentication Library não foi carregada.');
  }

  const msalClient = new window.msal.PublicClientApplication({
    auth: {
      clientId: MICROSOFT_CALENDAR_CLIENT_ID,
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: window.location.origin,
    },
  });

  const resultado = await msalClient.acquireTokenPopup({
    scopes: MICROSOFT_SCOPE,
  });

  return {
    access_token: resultado.accessToken,
    calendar_id: '',
  };
};
